import { render, staticRenderFns } from "./Incompatible.vue?vue&type=template&id=34cc8694&scoped=true"
import script from "./Incompatible.vue?vue&type=script&lang=js"
export * from "./Incompatible.vue?vue&type=script&lang=js"
import style0 from "./Incompatible.vue?vue&type=style&index=0&id=34cc8694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cc8694",
  null
  
)

export default component.exports